/* eslint-disable import/prefer-default-export */
export const FORM_BODY_MAX_WIDTH = 648;
